// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"31d1634a","290":"efc0c550","452":"8b650f00","510":"b54faa4b","517":"2a3706ff","633":"474f94e4","677":"85efb8bb","693":"d8b001a8","972":"ae4bbf17"}[chunkId] + ".chunk.js";
};